export const engagementLandingPagesAppGroupIdSizeLimits = "/engagement/landing_pages/:app_group_id/size_limits";
